import axios from 'axios';
import log from 'chameleon/ui-stack/utilities/log';

function trackExternalResource(event, url) {
  event.preventDefault();

  const redirectUrl = url;

  axios
    .get(`${FYM_UNITS_BACKEND_URL}/redirect/`, {
      params: {
        dest_url: encodeURIComponent(redirectUrl),
        src_url: window.location.href,
        env: process.env.ENV,
      },
    })
    .catch((error) => log('error', error));
  window.open(redirectUrl, '_blank');
  return false;
}

export default trackExternalResource;
